<template>
  <div class="d-flex pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="flex-grow-1 modal-title align-self-center">CSV出力</h4>
  </div>  
  <div>
    <div class="container-fluid m-1 pl-1">
      <div class="card">
        <div class="row mt-3">
          <span>
            {{numberOfSelect}}件のデータが選択されています。
          </span>
        </div>
        <div class="row mt-3">
          <span>
            CSVファイルはフォーム設定単位で作成を行います。
            
          </span>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 mt-3">
            <div class="row">
              <div class="col-4">
                <base-button
                  block
                  type="secondary"
                  @click="onClickCancel"
                  >キャンセル</base-button
                >
              </div>
              <div class="col-4">
                
              </div>
              <div class="col-4">
                <base-button
                  block
                  type="primary"
                  @click="onClickMakeForm"
                  >帳票作成</base-button
                >
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<style scoped>
  /** このVueだけのスタイル */
</style>
<style >
  /** 全体に影響するスタイル */
</style>
<script>
import appLog from "@/appUtils/AppLog"
import FormTemplateModel from "@/appModel/FormTemplate/FormTemplateModel"
// import DateUtil from "@/appUtils/DateUtil"
// import UserInfo from "@/appUtils/UserInfo"

export default {
  components: {

  },
  /**
   * プロパティ
   */
  props: {
    /**
     * プロジェクトID
     */
    selectedList: {
      type: Array,
    },
  },
  data() {
    return {
      formTemplateDatas: [],
      formRadioList: [],
      selectTemplateData: null,
      selectedFormId: null,
      loader: null
    };
  },
  computed: {
    vuename() {
      return this.$route.name
    },
    numberOfSelect() {
      if (this.selectedList) {
        if (this.selectedList.length) {
          return this.selectedList.length
        } else {
          return 0
        }
      }
      return 0
    }
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    //インスタンスが生成され､且つデータが初期化された後
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    appLog.infoLog(`${this.vuename}`, `Start ${this.vuename}`)
    this.init()
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    init() {
      
      this.loadTemplateData().then((result) => {
        console.log(``)
      })
    },
    // setupRadioData() {
    //   this.formTemplateDatas.forEach(function(item) {
    //     item.
    //   }.bind(this))
    // },
    /**
     * 帳票データをDBから読み込み
     */
    async loadTemplateData(){
      this.formTemplateDatas = await FormTemplateModel.getFormTemplateList()
      return this.formTemplateDatas
    },
    onSelectTemplate() {
      //alert(this.selectedFormId)
      let selectTemplateDatas = this.formTemplateDatas.filter(function(item) {
        return item.formTemplate.id == this.selectedFormId
      }.bind(this))
      if (selectTemplateDatas.length > 0) {
        this.selectTemplateData = selectTemplateDatas[0]
      }
    },
    onClickCancel() {
      this.$emit("cancel")
    },
    onClickMakeForm(){

      this.$emit("makeForm", )
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader(isShow = true) {
      if (isShow) {
        this.loader = this.$loading.show();
      } else {
        if (this.loader === null) {
          return;
        }
        this.loader.hide();
        this.loader = null;
      }
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader(loader) {
      this.showLoader(false)
      // loader.hide();
    },
  },
};
</script>
